import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import {FilterItem} from './FilterItem';

export default connect(
  createStructuredSelector({
    userId,
    highestRankDescription: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
    paidAsRankDescLastMonth: withProps({coachId: userId})(
      paidAsRankDescLastMonth,
    ),
  }),
)(FilterItem);
